import { useQuery } from '@tanstack/react-query';
import { cityApi } from '../api/city.api';
import { cityKeys } from '../api/city.keys';
import type { City } from '@/shared/types';

export function useCityDetails(id: string | number | undefined) {
  return useQuery<City>({
    queryKey: cityKeys.detail(id!),
    queryFn: () => cityApi.getById(id!),
    enabled: !!id,
  });
}
